{
    "CodeList_Column_Description": "Descrizione",
    "CodeList_Column_Code": "Codice",
    "CodeList_Column_Type": "Tipo",
    "CodeList_Column_TelSys": "Server di telefonia",
    "CodeList_Column_Partition": "Partizione",
    "CodeList_Partition_Any": "Qualunque",
    "CodeList_Scope_All": "Tutto",
    "CodeList_Scope_ServiceWide": "Ampia gamma di servizi",
    "CodeList_Scope_SystemWide": "a livello di sistema",
    "CodeList_Scope_Detached": "Distaccato",
    "CodeList_Type_All": "Tutto",
    "CodeList_Type_Account": "Account",
    "CodeList_Type_ACD_NotAvailable": "ACD non disponibile",
    "CodeList_Scope_Label": "Ambito di applicazione",
    "CodeList_Type_Label": "Tipo",
    "CodeList_Change_AnyPartitionNotSupported": "I codici presenti nella partizione \"Qualsiasi\" non possono essere modificati o visualizzati qui. Filtra l'elenco in base a una partizione specifica per modificare o visualizzare un codice.",
    "NAME": "Elenco codiciLingua"
}